export const loaderImg = (w: number, h: number) => `https://via.placeholder.com/${w}x${h}`;

